// Icon set used by the persona dashboard, mapped 1:1 to the assets referenced
// in Claude Design "Persona Dashboard Redesign" / DashboardRevampContent.dc.html
// (`assets/brand/*.svg`, `assets/pieces-cc/*.svg`, medal svgs).
//
// The design project's brand icons were generated from this repo, so every one
// already exists under src/Assets — these are the same files, not lookalikes.
// Centralised here so the dashboard components share one source of truth
// instead of scattering require() calls (and so swapping an icon is one edit).

export const dsIcons = {
  // assets/brand/*
  gameAnalytics: require('@/Assets/Images/Svgs/home_page/game_analytics.svg'),
  assessment: require('@/Assets/Images/Svgs/home_page/assessment.svg'),
  tournament: require('@/Assets/Images/Svgs/home_page/tournament.svg'),
  gamePlay: require('@/Assets/Images/Svgs/home_page/game_play.svg'),
  learning: require('@/Assets/Images/Svgs/home_page/learning.svg'),
  positionsTrainer: require('@/Assets/Images/Svgs/home_page/positions_trainer.svg'),
  calculationTrainer: require('@/Assets/Images/Svgs/home_page/calculation_trainer.svg'),
  intuitionTrainer: require('@/Assets/Images/Svgs/home_page/intuition_trainer.svg'),
  chessEvents: require('@/Assets/Images/Svgs/home_page/chess_events.svg'),
  play: require('@/Assets/Images/Svgs/home_page/play.svg'),

  // medals — leaderboard top 3 (design renders these instead of a rank number)
  goldMedal: require('@/Assets/Images/Svgs/goldMedal.svg'),
  silverMedal: require('@/Assets/Images/Svgs/silverMedal.svg'),
  bronzeMedal: require('@/Assets/Images/Svgs/bronzeMedal.svg'),

  // assets/pieces-cc/White-Knight.svg — the hero's "start a game" chip
  whiteKnight: require('@/Assets/ChessPieces/White-Knight.svg'),
};

export const MEDAL_BY_RANK: Record<number, any> = {
  1: dsIcons.goldMedal,
  2: dsIcons.silverMedal,
  3: dsIcons.bronzeMedal,
};
